var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 26.25L15 2.5L28.75 26.25H1.25ZM5.5625 23.75H24.4375L15 7.5L5.5625 23.75ZM15 22.5C15.3542 22.5 15.6513 22.38 15.8913 22.14C16.1313 21.9 16.2508 21.6033 16.25 21.25C16.2492 20.8967 16.1292 20.6 15.89 20.36C15.6508 20.12 15.3542 20 15 20C14.6458 20 14.3492 20.12 14.11 20.36C13.8708 20.6 13.7508 20.8967 13.75 21.25C13.7492 21.6033 13.8692 21.9004 14.11 22.1412C14.3508 22.3821 14.6475 22.5017 15 22.5ZM13.75 18.75H16.25V12.5H13.75V18.75Z",
    fill: "#E74B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.d12465ce5dcfd2418b43dcc6b54ab277.svg";
export { ForwardRef as ReactComponent };